import React, { useState } from "react";
import styles from "./Packages.module.scss";
import { OrderPackagesDataType } from "../../../../interface/site.interface";
import CustomCheckbox from "../../../shared/checkBox/CheckBox";
import checked from "../../../../assets/images/pages/login/checkboxMessage.svg";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";

interface Props {
  visible: boolean;
  onClose: () => void;
  packages: OrderPackagesDataType[];
  selectedPackages: number[];
  setSelectedPackages: (value: number[]) => void;
  handlePostOnChange: () => void;
  setSelectedPackageObjects: (value: OrderPackagesDataType[]) => void;
  showAllPackages: boolean;
  setShowAllPackages: (value: boolean) => void;
}

const PackagesModal: React.FC<Props> = ({
  visible,
  onClose,
  packages,
  selectedPackages,
  setSelectedPackages,
  handlePostOnChange,
  setSelectedPackageObjects,
  showAllPackages,
  setShowAllPackages,
}) => {
  const { userInfo } = useSelector((state: RootState) => state.userProfile);
  const { data } = useSelector((state: RootState) => state.translationData);

  // const filteredPackages = showAllPackages
  //   ? packages
  //   : packages.filter((pkg) => pkg.client_id === userInfo?.id);

  const ownPackages = packages.filter((pkg) => pkg.client_id === userInfo?.id);
  const referalPackages = packages.filter(
    (pkg) => pkg.client_id !== userInfo?.id,
  );

  const filteredPackages = showAllPackages
    ? [...ownPackages, ...referalPackages]
    : ownPackages.length > 0
      ? ownPackages
      : referalPackages;

  const togglePackageSelection = (packageId: number) => {
    const newSelectedIds = selectedPackages.includes(packageId)
      ? selectedPackages.filter((id) => id !== packageId)
      : [...selectedPackages, packageId];
    setSelectedPackages(newSelectedIds);
  };

  const toggleSelectAllPackages = () => {
    if (selectedPackages.length === filteredPackages.length) {
      setSelectedPackages([]);
    } else {
      const allIds = filteredPackages.map((pkg) => pkg.id);
      setSelectedPackages(allIds);
    }
  };

  const allPackagesSelected =
    filteredPackages.length > 0 &&
    selectedPackages.length === filteredPackages.length;

  const handleSelect = () => {
    setSelectedPackages(selectedPackages);
    const selectedObjects = packages.filter((pkg) =>
      selectedPackages.includes(pkg.id),
    );
    setSelectedPackageObjects(selectedObjects);
    handlePostOnChange();
    onClose();
  };

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <h2 className={styles.modalTitle}>{data?.select_package}</h2>

        <div className={styles.selectAllContainer}>
          <div>
            <CustomCheckbox
              icon={checked}
              text={data?.auth_common_select_all_packages}
              color="green"
              checked={allPackagesSelected}
              onChange={toggleSelectAllPackages}
              containerClassName={styles.selectAllCheckbox}
            />
          </div>
        </div>

        {filteredPackages.length > 0 ? (
          <div>
            <div className={styles.tableWrapper}>
              <table className={styles.packageTable}>
                <thead>
                  <tr>
                    <th></th>
                    <th className={styles.th}>
                      <p>{data?.auth_common_tracking_code}</p>{" "}
                      {/* İzləmə Kodu */}
                      <p className={styles.line}></p>
                    </th>
                    <th className={styles.th}>
                      <p>{data?.weight}</p>
                      <p className={styles.line}></p>
                    </th>
                    <th className={styles.th}>
                      <p>{data?.shipping_amount}</p>
                      <p className={styles.line}></p>
                    </th>
                    <th className={styles.th}>
                      <p>{data?.auth_common_foreign_debt}</p>
                      <p className={styles.line}></p>
                    </th>
                    <th className={styles.th}>
                      <p>{data?.auth_common_local_debt}</p>

                      <p className={styles.line}></p>
                    </th>
                    <th className={styles.th}>
                      <p>{data?.auth_courier_payment_type}</p>{" "}
                      {/* Ödəniş növü */}
                      <p className={styles.line}></p>
                    </th>
                    <th className={styles.th}>
                      <p>{data?.customer}</p>
                      <p className={styles.line}></p>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredPackages.map((pkg) => (
                    <tr
                      key={pkg.id}
                      onClick={() => togglePackageSelection(pkg.id)}
                      className={
                        selectedPackages.includes(pkg.id)
                          ? styles.selectedRow
                          : ""
                      }
                    >
                      <td onClick={(e) => e.stopPropagation()}>
                        <div className={styles.package_checkBox}>
                          <CustomCheckbox
                            icon={checked}
                            text=""
                            color="green"
                            checked={selectedPackages.includes(pkg.id)}
                            onChange={() => togglePackageSelection(pkg.id)}
                            containerClassName={styles.td_checkbox}
                          />
                        </div>
                      </td>
                      <td>{pkg.track}</td>
                      <td>
                        {pkg.gross_weight}{" "}
                        <span style={{ marginLeft: "10px" }}>kg</span>
                      </td>
                      <td>
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "2px" }}>
                          {pkg.discount_color && (
                            <span
                              style={{
                                color: pkg.discount_color,
                                textDecoration: "line-through",
                                fontSize: "12px",
                              }}
                            >
                              {pkg.amount} AZN
                            </span>
                          )}
                          <span>
                            {pkg.discount_color
                              ? pkg.discounted_amount
                              : pkg.amount}{" "}
                            AZN
                          </span>
                        </div>
                      </td>
                      <td>
                        {pkg.external_w_debt}{" "}
                        <span style={{ marginLeft: "10px" }}>AZN</span>
                      </td>
                      <td>
                        {pkg.internal_w_debt}{" "}
                        <span style={{ marginLeft: "10px" }}>AZN</span>
                      </td>
                      <td>{pkg.payment_type}</td>
                      <td>
                        {pkg.client_name} {pkg.client_surname}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className={styles.actions}>
              <button
                className={styles.secondaryBtn}
                onClick={() => setShowAllPackages(!showAllPackages)}
              >
                {showAllPackages
                  ? data?.auth_left_sidebar_parcels
                  : data?.auth_common_show_all_packages}
              </button>

              <button className={styles.primaryBtn} onClick={handleSelect}>
                {data?.auth_attorney_select}
              </button>
            </div>
          </div>
        ) : (
          <p className={styles.noPackagesMessage}>
            {showAllPackages
              ? data?.package_not_found
              : data?.package_not_found}
          </p>
        )}
      </div>
    </div>
  );
};

export default PackagesModal;
